import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgPhone20 = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 20,
	height: 20,
	viewBox: "0 0 20 20",
	fill: "#2E9AB7",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("g", {
		id: "Phone",
		children: /* @__PURE__ */ _jsx("path", {
			id: "Icon",
			d: "M6.04622 13.9454C2.05097 9.95012 0.349057 5.17446 1.99416 3.52935L3.34593 2.17758C4.12698 1.39654 5.39331 1.39653 6.17435 2.17758L8.84344 4.84667C9.4087 5.41192 9.41196 6.32636 8.85323 6.89565L7.95538 7.7935L7.95686 7.79498C7.52672 8.30793 8.08299 9.61819 9.22821 10.7634C10.3734 11.9086 11.6837 12.4649 12.1966 12.0348L12.198 12.0361L12.225 12.0091L12.2308 12.0035L12.2364 11.9977L13.0765 11.1576C13.0797 11.1545 13.0829 11.1513 13.0861 11.1482C13.6546 10.5796 14.5764 10.5796 15.145 11.1482L17.814 13.8172C18.5951 14.5983 18.5951 15.8646 17.814 16.6457L16.4622 17.9974C14.8171 19.6425 10.0415 17.9406 6.04622 13.9454Z",
			fill: "current"
		})
	})]
});
const ForwardRef = forwardRef(SvgPhone20);
export { ForwardRef as ReactComponent };
